import React, { Fragment } from 'react';
import OptionShimmer from './option.shimmer';
var OPTION_COUNT = 2;
export default (function () {
  return React.createElement(Fragment, null, Array.from({
    length: OPTION_COUNT
  }).fill(null).map(function (item, index) {
    return React.createElement(OptionShimmer, {
      key: "product-option-".concat(index)
    });
  }));
});